import React, {useEffect} from 'react';
import track from 'utils/track';
import SalesIndex from '../join';

export default function () {
  useEffect(
    () =>
      track('Product Viewed', {
        product_id: 'SC-PPP',
        sku: 'SC-PPP',
        name: 'Plant-Powered Playbook',
        variant: 'ppp-special',
        value: 97,
        currency: 'usd'
      }),
    []
  );
  return (
    <SalesIndex
      noFixedVideo
      noExitIntent
      ctaNoTimer
      ctaOverride="joinSales"
      variant="ad"
      bucketOverride="curious"
      pageTitle="Food Revolution Network’s Plant-Powered Playbook"
      pageDescription="Want to finally find the health of your dreams while eating delicious food?"
      ogImage="https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-sales-veg-curious-1200x1200-v20221026.jpg"
      shareUrl="https://plantplaybook.foodrevolution.org/a/join-plantbased/"
      facebookDescription="Heard a lot about how a plant-based diet can transform your health but have no idea where to start? The Plant-Powered Playbook shows you how to make food the foundation of your health. Learn more here:"
      twitterDescription="Heard a lot about how a plant-based diet can transform your health but have no idea where to start? The Plant-Powered Playbook shows you how to make food the foundation of your health. Learn more here:"
      twitterImg="https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-sales-veg-curious-1200x675-20221026.jpg"
      pinterestDescription="Heard a lot about how a plant-based diet can transform your health but have no idea where to start? The Plant-Powered Playbook shows you how to make food the foundation of your health. Learn more here:"
      pinterestImage="https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-sales-veg-curious-1000x1500-20221026.jpg"
    />
  );
}
